import React from "react";
import { Text } from "@chakra-ui/react";
import NavHeader from "../common/NavHeader";

const Marketplace = () => (
  <div>
    <NavHeader />
    <Text>coming soon!</Text>
  </div>
);
export default Marketplace;
